import React from "react";

import MultiGrid, { MultiGridCellRendererProps } from "../MultiGrid/MultiGrid";
import SkeletonCard from "../Skeleton/SkeletonCard";

import { action, computed, makeObservable, observable } from "mobx";
// import DataGridBodyCell from './ScheduleGrid.Cells/ScheduleGrid.BodyCell';
// import DataGridHeaderCell from './ScheduleGrid.Cells/ScheduleGrid.HeaderCell';
import injectStores from "../RootStore/injectStores";
import ScheduleGridLeftHeaderCell from "./ScheduleGrid.LeftHeaderCell";
import ScheduleGridRightHeaderCell from "./ScheduleGrid.RightHeaderCell";
import ScheduleGridLeftBodyCell from "./ScheduleGrid.LeftBodyCell";
import ScheduleGridRightBodyCell from "./ScheduleGrid.RightBodyCell";

import { ScheduleGridProps } from "types/ScheduleGridTypes";

class ScheduleGrid extends React.PureComponent<ScheduleGridProps> {
  namespaceId = "";
  constructor(props: ScheduleGridProps) {
    super(props);
    makeObservable(this, {
      namespaceId: observable,
      setNamespaceId: action,
    });

    this.setupScheduleGrid();
  }

  setNamespaceId = (newNamespaceId: string) => {
    if (this.props.debugMode)
      console.log("Setting namespaceId", newNamespaceId);
    this.namespaceId = newNamespaceId;
  };

  setupScheduleGrid = () => {
    const {
      scheduleGridStore,
      storeName,
      uniqueKey,
      columnHeaders,
      // defaultFilter,
      customEntity,
      namespace,
      dateKey,
    } = this.props;
    if (!scheduleGridStore) {
      throw new Error("ScheduleGridStore is required");
    }

    const namespaceId = scheduleGridStore.setupNamespace(namespace);
    // console.log('setupScheduleGrid namespaceId', namespaceId);
    this.setNamespaceId(namespaceId);
    const currentDataGridStore = scheduleGridStore.namespaces[namespaceId];

    if (storeName) {
      currentDataGridStore.setCurrentStoreName(storeName);
    }
    if (uniqueKey) {
      currentDataGridStore.setUniqueKey(uniqueKey);
    }
    if (columnHeaders) {
      currentDataGridStore.setColumnHeaders(columnHeaders);
    }
    if (dateKey) {
      currentDataGridStore.setDateKey(dateKey);
    }
    // if (defaultFilter) {
    //   currentDataGridStore.setDefaultFilter(
    //     defaultFilter as Record<string, string>
    //   );
    // }
    if (customEntity) {
      currentDataGridStore.setEntityValue(customEntity as string);
    }
  };

  componentDidMount() {
    addEventListener("keydown", this.keyPressHandler, false);
  }

  componentWillUnmount() {
    removeEventListener("keydown", this.keyPressHandler, false);
    const { autoReset = false } = this.props;
    if (autoReset) {
      if (this.namespaceId) {
        const scheduleGridStore = this.props.scheduleGridStore;
        if (this.props.debugMode)
          console.log("Clearing namespaceId", this.namespaceId);
        scheduleGridStore?.clearNamespace(this.namespaceId);
      }
    }
  }

  keyPressHandler = (event: KeyboardEvent) => {
    // const { onSubmitEdits, onRemove, scheduleGridStore } = this.props;
    // const currentStore = scheduleGridStore.namespaces[this.namespaceId];
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      // currentStore?.resetEditData();
      // if (currentStore?.removeColumnEnabled) {
      //   currentStore?.toggleRemoveColumn();
      // }
    }
    // if (event.key === 'Enter') {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   Object.entries(currentStore?.editData).map(([key, value]) => {
    //     Object.entries(value as { [key: string]: boolean | string }).map(
    //       ([changedKey, changedValue]) => {
    //         if (changedValue === 'True') {
    //           value[changedKey] = true;
    //         }
    //         if (changedValue === 'False') {
    //           value[changedKey] = false;
    //         }
    //       }
    //     );
    //     onSubmitEdits(key, value);
    //     currentStore?.removeEditData(key);
    //   });
    // }
    // if (!!onRemove && event.ctrlKey && event.key === 'Delete') {
    //   currentStore?.toggleRemoveColumn();
    // }
  };

  getColumnWidth = ({ index }: { index: number }) => {
    const { columnWidth = 150 } = this.props;
    const scheduleGridStore = this.props.scheduleGridStore;
    if (!scheduleGridStore) {
      throw new Error("ScheduleGridStore is required");
    }
    const currentStore = scheduleGridStore.namespaces[this.namespaceId];
    if (
      currentStore?.currentColumnHeaders &&
      currentStore.currentColumnHeaders[index] &&
      "width" in currentStore.currentColumnHeaders[index]
    ) {
      return currentStore.currentColumnHeaders[index].width as number;
    }
    return columnWidth;
  };

  // get currentStore() {
  //   console.log('this.namespaceId', this.namespaceId);
  //   console.log('this.props', this.props);
  //   // const { scheduleGridStore } = this.props;
  //   const scheduleGridStore = this.props.scheduleGridStore;
  //   const { namespaces } = scheduleGridStore;
  //   return namespaces[this.namespaceId];
  // }

  get saveLocation() {
    if (!this.props.enableSaveLocation) {
      return undefined;
    }
    const routerStore = this.props.rootStore?.routerStore;
    return `${this.namespaceId}_${
      routerStore?.currentPath || "default"
    }_saveLocation`;
  }

  render() {
    // trace();
    const {
      height,
      width,
      loading = false,
      rowHeight = 50,
      fixedColumnCount = 1,
      fixedRowCount = 1,
      onRowClick,
      enableHover = true,
      enableInlineEdit = false,
      enableFullGridEdit,
      onSubmitEdits,
      onRemove,
      rootStore,
    } = this.props;
    const scheduleGridStore = this.props.scheduleGridStore;
    // console.log('scheduleGridStore', scheduleGridStore);
    if (!scheduleGridStore) {
      return <SkeletonCard height={height} width={width} />;
    }

    // console.log('loading', loading);
    // console.log('scheduleGridStore', scheduleGridStore);
    // console.log('this.namespaceId', this.namespaceId);
    const currentStore = scheduleGridStore.namespaces[this.namespaceId];

    // console.log('currentStore', currentStore);

    if (loading || !this.namespaceId || !currentStore) {
      // console.log('returning skeleton');
      return <SkeletonCard height={height} width={width} />;
    }

    const currentRows = computed(
      () =>
        currentStore?.currentRows.map((i: object) => {
          return { ...i };
        }) || []
    ).get();
    // console.log('currrentRows', currentRows);

    const currentHeight = computed(() => {
      if (height) {
        return height;
      }
      return rootStore?.viewStore?.cardBodySize?.height || 500;
    }).get();

    const currentWidth = computed(() => {
      if (width) {
        return width;
      }
      return rootStore?.viewStore?.cardBodySize?.width || 500;
    }).get();
    return (
      <div
        style={{
          height: currentHeight,
          width: currentWidth,
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
        }}
        onMouseLeave={() => {
          currentStore?.resetCellHover();
        }}
      >
        <MultiGrid
          height={currentHeight}
          width={currentWidth}
          rowHeight={
            typeof rowHeight === "function"
              ? (rowIndex: { index: number }) => rowHeight(rowIndex, rootStore)
              : rowHeight
          }
          columnWidth={this.getColumnWidth}
          enableFixedRowScroll={true}
          enableFixedColumnScroll={true}
          data={currentRows}
          columnKeys={currentStore?.currentColumnKeys || []}
          fixedColumnCount={fixedColumnCount}
          fixedRowCount={fixedRowCount}
          setRef={(ref: { recomputeGridSize: () => void } | null) =>
            currentStore?.setSchedulerRef(ref)
          }
          saveLocation={this.saveLocation}
          leftHeaderCellRenderer={(props: MultiGridCellRendererProps) => {
            const { key, ...rest } = props;
            // console.log('leftHeaderCellRenderer', props);
            return (
              <ScheduleGridLeftHeaderCell
                key={key}
                {...rest}
                namespaceId={this.namespaceId}
                style={props.style}
              />
            );
          }}
          rightHeaderCellRenderer={(props: MultiGridCellRendererProps) => {
            const { key, ...rest } = props;
            // console.log('rightHeaderCellRenderer', props);
            return (
              <ScheduleGridRightHeaderCell
                key={key}
                {...rest}
                namespaceId={this.namespaceId}
                style={props.style}
              />
            );
          }}
          leftBodyCellRenderer={(props: MultiGridCellRendererProps) => {
            const { key, ...rest } = props;
            // console.log('leftBodyCellRenderer', props);

            return (
              <ScheduleGridLeftBodyCell
                key={key}
                {...rest}
                namespaceId={this.namespaceId}
                onRowClick={onRowClick}
                enableHover={enableHover}
                enableInlineEdit={enableInlineEdit}
                enableFullGridEdit={enableFullGridEdit}
                onSubmitEdits={onSubmitEdits}
                onRemove={onRemove}
                style={props.style}
              />
            );
          }}
          rightBodyCellRenderer={(props: MultiGridCellRendererProps) => {
            const { key, ...rest } = props;
            // console.log('rightBodyCellRenderer', props);
            return (
              <ScheduleGridRightBodyCell
                key={key}
                {...rest}
                namespaceId={this.namespaceId}
                onRowClick={onRowClick}
                enableHover={enableHover}
                enableInlineEdit={enableInlineEdit}
                enableFullGridEdit={enableFullGridEdit}
                onSubmitEdits={onSubmitEdits}
                onRemove={onRemove}
                style={props.style}
              />
            );
          }}
        />
      </div>
    );
  }
}

export default injectStores(ScheduleGrid);
